<template>
  <TableLayout :permissions="['business:member:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="用户" prop="nickname">
        <el-input v-model="searchForm.nickname" placeholder="请输入昵称/手机号/真实姓名" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        border
      >
        <el-table-column prop="creator" label="用户" align="center" min-width="100px">
          <template slot-scope="{row}">
            <el-image style="width: 60px; height: 60px; border-radius: 50%;" :src="row.imgFullUrl"></el-image>
            {{ row.nickName }}
          </template>
        </el-table-column>
        <el-table-column prop="nickname" label="昵称" align="center"  min-width="100px"></el-table-column>
        <el-table-column prop="name" label="真实姓名" align="center"  min-width="100px"></el-table-column>
        <el-table-column prop="phone" label="手机号" align="center"  min-width="100px"></el-table-column>
        <el-table-column prop="idcard" label="身份证号" align="center"  min-width="100px"></el-table-column>
        <el-table-column prop="integral" label="咖豆数量" align="center"  min-width="100px"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" align="center"  min-width="140px"></el-table-column>
        <el-table-column label="状态" align="center"  min-width="100px">
          <template slot-scope="{row}">
            <el-switch
              v-model="row.status"
              active-color="#13ce66"
              inactive-color="#999"
              :active-value="0"
              :inactive-value="1"
              @change="statusChange(row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center"  min-width="100px">
          <template slot-scope="{row}">
            <el-button type="text" @click="showMemberDetail(row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
      <OperaMemberDetail ref="operaMemberDetail" />
    </template>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaMemberDetail from '@/components/business/OperaMemberDetail'
import { updateById } from '@/api/business/member'
export default {
  name: 'Member',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaMemberDetail },
  data () {
    return {
      // 搜索
      searchForm: {
        nickname: ''
      }
    }
  },
  created () {
    this.config({
      module: '用户信息表',
      api: '/business/member',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  },
  methods: {
    statusChange(row) {
      console.log(row);
      updateById(row)
        .then(() => {
          this.$tip.success('修改成功')
        })
        .catch(e => {
          this.$tip.error(e)
        })
        .finally(() => {
          this.handlePageChange()
        })
    },
    showMemberDetail(row) {
      this.$refs.operaMemberDetail.open('会员详情', row)
    }
  }
}
</script>

<style scoped>
::v-deep .el-input{
  width: 200px;
}
</style>
